module.exports = __webpack_public_path__ + "static/media/Generator-1.5885d298.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Generator-1.jpg
// module id = 118
// module chunks = 0